import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from "inversify";
import NeoTypes from '../AppServices/NeoTypes';
var RouteSecurityService = /** @class */ (function () {
    function RouteSecurityService(authorisationService) {
        this.authorisationService = authorisationService;
    }
    /**
     * Checks if the route is allowed to render.
     * @param route Route data.
     */
    RouteSecurityService.prototype.routeAllowed = function (route) {
        var _this = this;
        if (route.role) {
            return this.authorisationService.hasRole(route.role);
        }
        else if (route.anyRoles) {
            return route.anyRoles.some(function (role) { return _this.authorisationService.hasRole(role); });
        }
        return true;
    };
    /**
    * Checks if the menu item can be displayed.
    * @param menuItem Menu item.
    */
    RouteSecurityService.prototype.menuItemAllowed = function (menuItem) {
        return this.routeAllowed(menuItem);
    };
    RouteSecurityService = __decorate([
        injectable(),
        __param(0, inject(NeoTypes.Security.AuthorisationService.symbol)),
        __metadata("design:paramtypes", [Object])
    ], RouteSecurityService);
    return RouteSecurityService;
}());
export { RouteSecurityService };
